import { Applicationcl } from './../Model/Applicationcl';
import { UserMaster } from 'src/app/Model/UserMaster';
import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/service/CommonService';
import { MasterConfigrationService } from 'src/app/service/MasterConfigrationService';
import { AutoLogoutService } from './../service/auto-logout.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { PartyUser } from '../Model/PartyUser';
import { ServiceStatus } from '../Model/ServiceStatus';
import { ResponseCode } from '../CheckResponse';
import { ForgotPassword } from '../Model/ForgotPassword';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: [ './changepassword.component.css' ]
})

export class ChangepasswordComponent implements OnInit {
  public oldPassword: string;
  public NewPassword: string;
  public NewConfirmPassword: string;
  public userId: number;
  public UserMasterValidationResult: boolean;

  constructor (private AutoLogoutService: AutoLogoutService, private _service: UserService
    , public oPartyUser: PartyUser, public commonservice: CommonService, public oApplicationcl: Applicationcl, private router: Router,
    public oAppComponent: AppComponent, public forgotPassword: ForgotPassword ) {
    this.AutoLogoutService.CheckAuthentication();
    this.userId = parseInt( sessionStorage.getItem( "userid" ) );
    this.oPartyUser.MOB_NUMBER = localStorage.getItem("loginuser");
  }

  ngOnInit() {
    this.GetOTP();
  }

  public GetOTP() {
    this.oApplicationcl.IsProgressBarEnable = true;
    this.forgotPassword.MobileNo = this.oPartyUser.MOB_NUMBER;
    this.forgotPassword.RequestSource = "ClientWebApp";
    this._service.GetOTP( this.forgotPassword ).subscribe(
      data => {
        this.oApplicationcl.IsProgressBarEnable = false;
      });
  }


  public ChangePassword(form: NgForm) {
    this.validateUserMasterControls();
    if (this.UserMasterValidationResult) {
      this.forgotPassword.CPassword = this.NewConfirmPassword;
      this.forgotPassword.Password = this.NewPassword;
      this.forgotPassword.OTP = this.oldPassword;
      this.forgotPassword.RequestSource = "ClientWebApp";
      this._service.ChangePassword( this.forgotPassword ).subscribe(
        data => {
          let oServiceStatus: ServiceStatus = data;
          if ( oServiceStatus.Status == ResponseCode.Success.toString() )
          {
            alert( "Password changed successfully" );
            this.signOut();
          }
          else { alert(oServiceStatus.ErrorMessage); }
        });
    }
  }

  signOut() {
    sessionStorage.clear();
    localStorage.clear();
    window.location.replace( '/' );
  }

  public validateUserMasterControls() {
    if (this.oldPassword == "" || this.oldPassword == undefined) {
      this.commonservice.focusInput(document.getElementById('txtOldPassword'));
      alert('OTP required');
      this.UserMasterValidationResult = false;
      return;
    }
    else if (this.NewPassword == "" || this.NewPassword == undefined) {
      this.commonservice.focusInput(document.getElementById('txtNewPassword'));
      alert('New password required');
      this.UserMasterValidationResult = false;
      return;
    }
    else if (this.NewPassword.length < 8) {
      this.commonservice.focusInput(document.getElementById('txtNewPassword'));
      alert('New password should be minimum 8 charectors');
      this.UserMasterValidationResult = false;
      return;
    }
    else if (this.NewConfirmPassword == "" || this.NewConfirmPassword == undefined) {
      this.commonservice.focusInput(document.getElementById('txtNewconfirmPassword'));
      alert('New confirm password required');
      this.UserMasterValidationResult = false;
      return;
    }
    else if (this.NewConfirmPassword != this.NewPassword) {
      this.commonservice.focusInput(document.getElementById('txtNewconfirmPassword'));
      alert('Password and confirm password should be same.');
      this.UserMasterValidationResult = false;
      return;
    }
    else {
      this.UserMasterValidationResult = true;
    }
  }
}
